<template>
  <div>
    <a-spin :spinning="loadingData">
      <div class="neo-tabs-classes" v-if="classId">
        <a-tabs :defaultActiveKey="selectedSection" :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'" @change="handleSectionChange">
          <a-tab-pane :key="0">
            <span slot="tab">
              Select Section
            </span>

            <div>
              <template v-if="selectedSection === 0 && !sections.length">
                <p v-if="!loading" class="font-weight-bold text-danger">No section exists for this class!</p>
              </template>
              <template v-else>
                <p class="font-weight-bold text-primary">Select section to manage internal marks!</p>
              </template>
            </div>
          </a-tab-pane>
          <a-tab-pane v-for="section in sections" :key="section.id">
            <span slot="tab">
              Section: {{ section.name }}
            </span>
              <internal-marks-list
                :settingData="data"
                :session="session"
                :classId="classId"
                :sectionId="selectedSection"
                :internalData="internalData"
                @saved="handleSettingsSaved"
              />
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="py-3" v-else>
        <p class="mb-0 text-warning">Select a class to manage internal assessment marks</p>
      </div>
    </a-spin>

  <internal-marks-form @updated="handleInternalMarkUpdate" />
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import InternalMarksList from '@/components/exam/internal/List/index'
import internalMarksForm from '@/components/exam/internal/Form/index'

export default {

  name: 'InternalMarksTable',
  components: {
    InternalMarksList,
    internalMarksForm,
  },
  props: {
    loading: Boolean,
    data: Object,
    session: Number,
    classId: Number,
    sections: Array,
  },
  data: function() {
    return {
      loadingData: false,
      selectedSection: 0,
      internalData: [],
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  watch: {
    classId: function() {
      this.selectedSection = 0
    },
  },
  methods: {
    moment,
    handleSectionChange(sectionId) {
      this.selectedSection = sectionId
      if (sectionId === 0) {
        this.loadingData = false
      } else {
        this.getStudentInternalMarks()
      }
    },
    handleSettingsSaved() {
      this.$emit('updateTable')
    },
    getStudentInternalMarks () {
      this.internalData = []
      this.loadingData = true
      this.$http.get('/api/finalstudentinternalassessmentmark', {
        params: {
          class_id: this.classId,
          section_id: this.selectedSection,
          session_id: this.session,
        },
      }).then(({ data }) => {
        this.loadingData = false
        this.internalData = data.data
      })
    },
    handleInternalMarkUpdate() {
      this.getStudentInternalMarks()
    },
  },
}
</script>
